/**
 * Create a random point within a sphere using spherical coordinates.
 *
 * See https://math.stackexchange.com/a/1586185 for formula reference.
 *
 * @param radius The radius of the full sphere.
 * @param radiusRange The fill ratio of the sphere. 0 means shell only, 1 means full sphere.
 * @returns A random point in the sphere of radius `radius`.
 */
export const randomPositionInSphere = (
  radius: number,
  radiusRange: number,
): [number, number, number] => {
  if (radius === 0) {
    return [0, 0, 0];
  }

  const r1 = Math.random();
  const r2 = Math.random();

  const latitude = Math.acos(2 * r1 - 1) - Math.PI / 2;
  const longitude = Math.PI * 2 * r2;

  const r = radius - radius * radiusRange * Math.random();
  const x = r * Math.cos(latitude) * Math.cos(longitude);
  const y = r * Math.cos(latitude) * Math.sin(longitude);
  const z = r * Math.sin(latitude);

  return [x, y, z];
};
